import React from 'react'

const PageFooter: React.FC<{}> = ({children}): React.ReactElement => {
  return <footer className={'page-footer p-0'}>{children}</footer>
}

export default PageFooter
